// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"300":"b51c78fe","592":"485482bb","856":"a9949d02","952":"2f25006a"}[chunkId] + ".chunk.js";
};